export default container =>
  container.querySelectorAll('[data-split-words]').forEach(el => {
    const { textContent } = el
    el.textContent = ''
    textContent
      .split(' ')
      .map(word => word.trim())
      .forEach(word => {
        const span = document.createElement('span')
        el.appendChild(span)
        span.style.marginRight = '0.3em'
        span.classList.add('slide-up')
        span.classList.add('d-inline-block')
        span.dataset.elementAnimate = ''

        const spanChild = document.createElement('span')
        span.appendChild(spanChild)
        spanChild.textContent = word
        spanChild.classList.add('slide-up__inner')
        spanChild.classList.add('d-inline-block')
        spanChild.classList.add('duration-1500')
      })
  })
